export function getPaginationSizes(): Array<number> {
  return [25, 50, 75]
}